import { useEffect } from "react";
import { type ResolvedTheme } from "@njbsoft/store";
import { useCustomerStore } from "@/store";

const DARK_SCHEME_QUERY = "(prefers-color-scheme: dark)";

function publishTheme(dark: boolean): void {
  const theme: ResolvedTheme = dark ? "dark" : "light";
  document.documentElement.classList.toggle("dark", dark);
  useCustomerStore.getState().setResolvedTheme(theme);
}

/**
 * Publishes the OS theme synchronously: `.dark` on `<html>` and the store's
 * `resolvedTheme`. `main.tsx` calls it before the first render because React
 * runs the signed-in layout's effects before the root route's, so the layout's
 * brand writer would otherwise apply the light roles under a dark OS first.
 */
export function seedResolvedTheme(): void {
  publishTheme(window.matchMedia(DARK_SCHEME_QUERY).matches);
}

/** The theme follows `prefers-color-scheme` alone, including while it changes. */
export function useThemeSync(): void {
  useEffect(() => {
    const query = window.matchMedia(DARK_SCHEME_QUERY);
    publishTheme(query.matches);
    const handler = (event: MediaQueryListEvent) => publishTheme(event.matches);
    query.addEventListener("change", handler);
    return () => query.removeEventListener("change", handler);
  }, []);
}
